import { deleteCustomer } from "actions/customers/customersActions";
import { deleteEquipment } from "actions/equipments/equipmentsActions";
import { deleteNotification } from "actions/notifications/notificationsActions";
import { deleteScheduler } from "actions/scheduler/schedulerActions";
import { deleteRegion } from "actions/regions/regionsActions";

export const getDeleteAction = moduleName => {
    console.log('mod',moduleName)
  switch (moduleName.toLowerCase()) {
    case "customers":
      return deleteCustomer;
    case "equipments":
      return deleteEquipment;
    case "regions":
      return deleteRegion;
    case "notifications":
      return deleteNotification;
    case "schedulers":
        return deleteScheduler;
    default:
      throw new Error("No matching module found.");
  }
};

export default getDeleteAction;
